module.exports = __webpack_public_path__ + "img/08_noff_close_L3.9b0412a0.svg";